import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import './css/index.css';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import config from './config'

const cognitoAuthConfig = {
  authority: config.authority,
  client_id: config.clientId,
  redirect_uri: config.redirect_uri,
  response_type: "code",
  scope: "email openid phone"
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
